import { useHistory } from 'react-router'
import React from 'react'

import { usePersistedState } from 'hooks'
import { entities } from 'reduxStore'

import Availability from 'components/EditPost/Availability'
import { EditedJobPost } from 'components/EditPost'

export default function EditJobPostAvailabilityPage() {
	const history = useHistory()
	const { mode }: { mode: 'post' | 'edit' } = history.location.state as any

	const [persistedJob, saveJob] = usePersistedState({
		entityName: entities.editedJobPost,
		initialValue: {} as EditedJobPost,
	})

	return (
		<Availability
			mode={mode}
			initAvailability={persistedJob.availability}
			isNextAvailable={false}
			onNext={(
				{
					availability,
				},
			) => {
				saveJob({
					...persistedJob,
					availability,
				})

				return 'postDates'
			}}
		/>
	)
}
